import { render } from "./RespondentWaveEntry.vue?vue&type=template&id=1865bc12"
import script from "./RespondentWaveEntry.vue?vue&type=script&lang=js"
export * from "./RespondentWaveEntry.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__